import { useState } from 'react';

import { Subhead02Text } from '../typography/typography';
import AlxButton from '../alx-components/button';
import { icons } from '../../assets/icons/icons';
import { CardInfoStyle } from './card-info-style';

type Data = {
  title: string;
  description?: string[];
  hiddenDescription?: string;
  separator?: boolean;
};

interface ICardInfo {
  actions?: { edit?: () => void; delete?: () => void; close?: () => void };
  title?: string;
  data: (string | Data)[];
  editStep?: boolean;
  dataCy?: string; // 👈 Cypress selector
}

const CardInfo: React.FC<ICardInfo> = ({ actions, data, title, dataCy, editStep }) => {
  const [showHiddenString, setShowHiddenString] = useState<string>('');

  const handleHiddenString = (string: string) => {
    if (showHiddenString === string) {
      return string;
    }
    return string.replace(/./g, '*');
  };

  return (
    <CardInfoStyle data-cy={dataCy}>
      <div className="card-info-top">
        {title && (
          <div className="card-info-top__title">
            <Subhead02Text weight={600}>{title}</Subhead02Text>
          </div>
        )}
        {actions && (
          <div className="card-info-top__actions">
            {actions.close && (
              <div
                data-cy="card-close-button"
                className="card-info-top__actions__item"
                onClick={() => actions.close && actions.close()}
              >
                <img src={icons.closeIcon} alt="close" />
              </div>
            )}
            {actions.edit && (
              <>
                {editStep ? (
                  <AlxButton
                    className="card-info-top__actions__item ghost"
                    onClick={() => actions.edit && actions.edit()}
                    data-cy="card-edit-button"
                  >
                    <img src={icons.editIcon} alt="" />
                  </AlxButton>
                ) : (
                  <AlxButton
                    data-cy="card-edit-button"
                    className="card-info-top__actions__item"
                    onClick={() => actions.edit && actions.edit()}
                  >
                    <img src={icons.editWhiteIcon} alt="" />
                  </AlxButton>
                )}
              </>
            )}
            {actions.delete && (
              <AlxButton
                data-cy="card-delete-button"
                className="card-info-top__actions__item card-info-top__actions__item--delete ghost"
                onClick={() => actions.delete && actions.delete()}
              >
                <img src={icons.deleteIcon} alt="" />
              </AlxButton>
            )}
          </div>
        )}
      </div>
      <div className="card-info-data">
        <ul>
          {data.map((item: string | Data, index: number) => {
            return typeof item === 'string' ? (
              <Subhead02Text as="li" key={`card-info-item-${index}`}>
                {item}
              </Subhead02Text>
            ) : (
              <div key={`card-info-item-${index}`} className="card-info-data__attribute">
                <Subhead02Text weight={600} className="card-info-data__title">
                  {item?.title ?? ''}
                </Subhead02Text>
                {item?.description &&
                  item.description.map((description, descriptionIndex) => (
                    <Subhead02Text
                      weight={500}
                      className="card-info-data__item"
                      as="li"
                      key={`card-info-item-${descriptionIndex}`}
                    >
                      {description}
                    </Subhead02Text>
                  ))}
                {item?.hiddenDescription && (
                  <div className="card-info-data__hidden">
                    <Subhead02Text as="li">{handleHiddenString(item.hiddenDescription)}</Subhead02Text>
                    <div
                      data-cy="show-hidden-text-button"
                      className="card-info-data__hidden-item"
                      onClick={() => {
                        setShowHiddenString((prevString) =>
                          item.hiddenDescription && prevString !== item.hiddenDescription ? item.hiddenDescription : '',
                        );
                      }}
                    >
                      <img src={icons.eyeIcon} alt="eye" />
                    </div>
                  </div>
                )}
                {item?.separator && <div className="card-info-data__separator" />}
              </div>
            );
          })}
        </ul>
      </div>
    </CardInfoStyle>
  );
};

export default CardInfo;
